import React from 'react'
import { Button, Chip, Grid, Typography } from '@mui/material'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import EditIcon from '@mui/icons-material/Edit'
import FactoryIcon from '@mui/icons-material/Factory'

export const CentroCard = ({ info, onEdit, onDelete }) => {
    return (
        <Grid
            container
            direction="column"
            size={{ xs: 12 }}
            sx={{
                justifyContent: "start",
                alignItems: "start",
                p: 2,
                gap: 1.5,
                ':hover': {
                    cursor: 'pointer',
                    backgroundColor: '#fff',
                },
                transition: 'all 0.3s ease-in-out',
            }}
            className='card-main'
        >
            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <Typography variant='h5'>
                    <FactoryIcon sx={{ mr: 1, fontSize: 30, mb: -0.5 }} />
                    {info.desAlmacen || 'Almacen sin nombre'}
                </Typography>

                <Chip size="small" label={`Codigo ${info.codAlmacen ?? '-'}`} variant="outlined" />
            </Grid>

            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <Button variant="text" color="primary" onClick={() => onEdit(info.codAlmacen)}>
                    <EditIcon />&nbsp;Editar
                </Button>

                <Button variant="text" color="error" onClick={() => onDelete(info)}>
                    <DeleteForeverIcon />&nbsp;Eliminar
                </Button>
            </Grid>
        </Grid>
    )
}
